/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import JSEncrypt from 'jsencrypt';
import URL from 'url-parse';
import { isObject, isString } from 'lodash';
import { encryptDes } from '@/utils/security';
import { generateRandomString } from '@/utils/generate';

/**
 * 公钥配置项
 */
const __PUBLIC_KEY_CONF__ = '__PUBLIC_KEY_CONF__';

/**
 * 是否使用公钥加密
 */
export const IS_PUBLIC_KEY_ENCRYPT = 'IS_PUBLIC_KEY_ENCRYPT';

/**
 * 参数加密的key
 */
const DES_KEY_NAME = 'Des-Key';

/**
 * 参数加密header的key
 */
const DES_KEY = 'jhs_0w-3';

const encrypt = new JSEncrypt();

/**
 * 获取公钥
 * @returns publicKey
 */
function getPublicKey() {
  const publicKey = window[__PUBLIC_KEY_CONF__]?.key || null;
  if (!publicKey) {
    console.warn('PublicKey不存在');
    return null;
  }
  return publicKey;
}

/**
 * 加密
 */
function encryptParameter(value, desKey = encrypt.encrypt(DES_KEY)) {
  return encryptDes(value, desKey);
}

/**
 * 包装Query参数
 */
export function encryptQueryValue(url, desKey) {
  // 创建URL对象
  const urlObj = new URL(url);
  const { query } = urlObj;
  if (query) {
    urlObj.query = `?data=${encryptParameter(query?.slice(1), desKey)}`;
  }
  // 返回加密后的URL字符串
  return urlObj.toString();
}

/**
 * 包装body参数
 */
export function encryptDataValues(data, desKey) {
  return { data: encryptParameter(data, desKey) };
}

/**
 * 添加请求拦截器
 */
export function addRequestInterceptors() {
  /**
   * 包装URL
   */
  const wrapperURL = (reqConfig, desKey) => {
    const rawReqURL = reqConfig.url;
    const transformReqURL = encryptQueryValue(rawReqURL, desKey);

    reqConfig.url = transformReqURL;
  };

  /**
   * 包装Body参数
   */
  const wrapperBody = (reqConfig, desKey) => {
    const reqData = reqConfig.data;
    if (!reqData) return;

    try {
      if (isString(reqData)) {
        const transformReqData = encryptDataValues(reqData, desKey);
        reqConfig.data = JSON.stringify(transformReqData);
      }

      if (isObject(reqData) && Object.keys(reqData)?.length > 0) {
        const transformReqData = encryptDataValues(JSON.stringify(reqData), desKey);
        reqConfig.data = JSON.stringify(transformReqData);
      }
    } catch (error) {
      console.error('JSON parse error:', error);
    }
  };

  /**
   * 包装请求头
   */
  const wrapperHeader = (reqConfig, desKey) => {
    const headers = reqConfig.headers || {};

    const encryptDesKey = encrypt.encrypt(desKey);

    reqConfig.headers = { ...headers, [DES_KEY_NAME]: encryptDesKey };
  };


  const resolvePath = (url = '') => {
    // 有些接口是自带有域名
    const withParamsPath = url.split('api')[1] ?? '';

    const path = withParamsPath.split('?')[0] ?? '';

    return path;
  };

  /**
   * 是否进行加密
   * @param {*} reqConfig 请求配置
   * @param {*} publicKey 公钥
   * @returns {Boolean}
   */
  const isEncrypt = (reqConfig, publicKey) => {
    const {
      list = [],
    } = window[__IGNORE_LIST_CONF__];

    const path = resolvePath(reqConfig.url);

    if (!publicKey) return false;
    if (list.includes(path)) return false;
    if (reqConfig[IS_PUBLIC_KEY_ENCRYPT] === false) return false;
    if (process.env[IS_PUBLIC_KEY_ENCRYPT] === false) return false;

    return true;
  };

  const onFulfilled = (config) => {
    const publicKey = getPublicKey();

    if (!isEncrypt(config, publicKey)) return config;

    encrypt.setPublicKey(publicKey);

    const desKey = generateRandomString(8);

    wrapperURL(config, desKey);

    wrapperBody(config, desKey);

    wrapperHeader(config, desKey);

    return config; // 返回这个配置对象，如果没有返回，这个请求就不会发送出去
  };

  const onRejected = Promise.reject.bind(null);

  return [onFulfilled, onRejected];
}
